import { rgba } from 'polished'
import styled from 'styled-components'

export const InfoCard = styled.div`
  width: 100%;
  padding: 12px;
  background-color: ${({ theme }) => theme.ds.colors.info50};
  border: 1px solid ${({ theme }) => rgba(theme.ds.colors.info500, 0.3)};
  border-radius: ${({ theme }) => theme.ds.typography.border.radius.small};
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const InfoCardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  }
`
